module.exports = __webpack_public_path__ + "media/images/arrow-left-e95ff5706c39aafc24b1154a98a6199a.svg";